export const fetchScanStatusData = async (payload) => {
    //configure api url
    const apiUrl = global.config.trackingServiceUrl + "/"
            + payload.awbPrefix + payload.airWaybillNumber
            + "/pieces/scans?create-date=" + payload.isoCreateDate;

    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Something went wrong ...');
    }

    return await response.json();
};




// WEBPACK FOOTER //
// ./src/api/scanStatusDataApi.js